import UnderConstruction from "@/components/feature/UnderConstruction";

export default function Privacy() {
  return <UnderConstruction title="プライバシーポリシー" />;
}